import { render, staticRenderFns } from "./unders.vue?vue&type=template&id=67d915e6&"
import script from "./unders.vue?vue&type=script&lang=ts&"
export * from "./unders.vue?vue&type=script&lang=ts&"
import style0 from "./unders.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports